
import React, { useState, useEffect, useContext } from "react";


import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import tmdbApi from "../../api/tmdbApi";
import moment from "moment";
import Modal from 'react-bootstrap/Modal';
import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../../context/contentContext";
import SessionPopup from "../SessionPopup"
import TableLoader from "../../components/tableLoader";
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { keyActivate } from "../../utils/a11y";

let { lambda, appname } = window.app

const ClientUserList = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { search } = state || {};
    const [toggle, setToggle] = useState(false);
    // const [data, setData] = useState([]);
    // const [userdata, setUserData] = useState([]);
    const [user, setUser] = useState("");

    // const [perpage, setPerpage] = useState(10);
    // const [arrow, setArrow] = useState(0);
    const [perpage, setPerpage] = useState(10);
    const [image, setImg] = useState('');
    // const [currentPage, setcurrentPage] = useState(1);
    const [itemsPerPage, setitemsPerPage] = useState(10);
    const [clientId, setClientId] = useState("")
    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [tableErrMsg, setTableErrMsg] = useState(false);
    const [deleteLoader, setDeleteLoader] = useState(false);
    const [arrowdir, setArrowDir] = useState('down');
    const [num, setNum] = useState();
    const [isDelete, setIsDelete] = useState(false)
    // const [sortDirection, setSortDirection] = useState('asc');


    const useruniqueid = localStorage.getItem("clientid")



    const [flag, setFlag] = useState(false);

    // const [isLoading, setIsLoading] = useState(false); 
    const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, userData, isRefreshed, setIsRefreshed, setUserData, clientInfo, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity } = useContext(contentContext)
    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu === "Pro Users")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard
    // console.log('validate obj', validateObj)
    // console.log('subValDashboard', subValDashboard)
    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute != route) {
            setCurrentPage(1)
            setRowsPerPage(15)
            setSearchedFlag(false);
            setUserSearch("")
        }
    }, [prevRoute]);
    //  // console.log('prevRoute--->',prevRoute)
    //  // console.log('currentRoute--->',route)

    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }


    }, [window.site]);



    useEffect(() => {
        const token = localStorage.getItem("token");

        if (!token) {
            navigate("/signin");
            return;
        }

        // Skip if clientInfo is still empty
        if (!clientInfo?.subscriptionPayment) return;

        if (clientInfo.subscriptionPayment !== "PAYMENT SUCCESS") {
            navigate("/signin");
        }
    }, [clientInfo, navigate]);



    const keyForRerender = `${rowsPerPage}_${data?.length}`;
    const columns = [

        {
            name: 'Name',
            selector: row => row?.contactname ?? "",
            sortable: true,
        },
        {
            name: 'User Type',
            selector: row => row?.usertype ?? "",
            sortable: true,
        },
        {
            name: 'Email id',
            selector: row => row?.emailId ?? "",
            sortable: true,
        },
        {
            name: 'Phone Number',
            selector: row => row?.phone ?? "",
            sortable: true,
        },
        {
            name: 'Status',
            selector: row => row?.status ?? "",
            sortable: true,
        },


        {
            name: 'Actions',
            cell: (props) =>
              subValDashboard &&
              (subValDashboard.view?.display || subValDashboard.edit?.display) && (
                <div className="d-flex" id={`clientuserActionButtons-${props.clientid}`}>
                  
                  {/* View Action */}
                  {subValDashboard.view?.display && (
                    <a
                      onClick={(e) => handleViewUser(e, props.clientid)}
                      onKeyDown={keyActivate((e) => handleViewUser(e, props.clientid))}
                      className={`text-success action-button ${!subValDashboard.view.enable ? 'pe-none' : ''}`}
                      id={`clientuserViewBtn-${props.clientid}`}
                    >
                      <i className="mdi mdi-eye font-size-18"></i>
                    </a>
                  )}
          
                  {/* Edit Action */}
                  {/* Edit Action */}
{subValDashboard.edit?.display && 
// (
//   props.clientid === useruniqueid ? 
//     <a
//       className={`text-danger action-button ${!subValDashboard.edit.enable ? 'pe-none' : ''}`}
//       id={`clientuserEditBtnSelf-${props.clientid}`}
//     >
//       <i className="mdi mdi-pencil font-size-18"></i>
//     </a>
//   :
    <a
      onClick={(e) => handleEditUser(e, props.clientid)}
      onKeyDown={keyActivate((e) => handleEditUser(e, props.clientid))}
      className={`text-danger action-button ${!subValDashboard.edit.enable ? 'pe-none' : ''}`}
      id={`clientuserEditBtn-${props.clientid}`}
    >
      <i className="mdi mdi-pencil font-size-18"></i>
    </a>
// )
}

          
                  {/* Delete Action */}
                  <a
                    onClick={() => handleDelete(props?.clientid)}
                    onKeyDown={keyActivate(() => handleDelete(props?.clientid))}
                    className={`text-danger action-button ${useruniqueid === props?.clientid ? 'pe-none' : ''}`}
                    style={{ position: "inherit" }}
                    id={`clientuserDeleteBtn-${props.clientid}`}
                  >
                    <i className="mdi mdi-delete font-size-18"></i>
                  </a>
          
                </div>
              ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
          }
          
    ];
    // console.log('subValDashboard1213123123123', subValDashboard)
    const handlePageChange = (page) => {
        GetTimeActivity()
        setCurrentPage(page);
    };

    const handlePerRowsChange = (newPerPage) => {
        GetTimeActivity()
        setRowsPerPage(newPerPage);
    };

    // console.log('datattatatattatat', data)
    useEffect(() => {
        setRoute("user")
        // GetUserData();
        setActiveMenuId(200004)
        setActiveMenuObj({
            "Client Management": false,
            "Contact Management": false,
            "Reports": false
        })
        setData([])
        userActivity();
    }, []);
    const handleCancel = () => {
        setIsDelete(false)
    }
    const handleClose = () => {
        setIsDelete(false)
    }
    const handleDeleteClient = () => {
        setDeleteLoader(true)
        const token = localStorage.getItem("token")
        let payload = {}
        payload = {

            "status": "ARCHIVE"


        }

        // if (checkStatus === false) {
        //     delete payload["status"];
        //     delete payload["userType"];
        // }

        axios({
            method: 'POST',
            url: lambda + '/clientUpdateUser?appname=' + appname + '&clientid=' + clientId + "&token=" + token,
            data: payload,
        })
            .then(function (response) {
                if (response) {
                    if (response?.result === "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                        setIsLoading(false);
                    }
                    //  else if (response?.data?.result === "This ACM assaigned to companies") {
                    //     setIsMsg(true);
                    //     setIsLoading(false);
                    // } 
                    else {
                        // setIsLoading(false);
                        // setUpdateSuccess(true)
                        // setToastMessage("User Details Updated Successfully")
                        // setToastType("success")
                        // GetClientDataContext()
                        User()
                        setIsDelete(false)
                        setDeleteLoader(false)
                    }
                }

            });
    }
    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = path[path.length - 1];
        let presentTime = moment();
        let payload;

        payload = {
            "clientid": localStorage.getItem("clientid"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


        const previousId = localStorage.getItem("previousid");
        const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)
                }
            });
    }
    const GetUserData = async () => {
        GetTimeActivity()
        try {

            const response = await tmdbApi.getUserData({});

            if (response?.statusCode === 200) {

                // setUserData(response?.result?.[0]);
                localStorage.setItem("ClientName", response?.result?.[0]?.name)
                localStorage.setItem("ClientType", response?.result?.[0]?.type)
                let userArr = response?.result?.[0]?.permissions

                const obj = userArr.reduce((acc, item) => {
                    if (item.submenus) acc[item.menu] = false;
                    return acc;
                }, {});
                // // console.log('objjjjjjjj--->',obj)
                // setActiveMenuObj(obj)

                // console.log('response?.result?.[0]', response?.result?.[0])
            }
        } catch {
            // console.log("error");
        }
    };


    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/signin");
        }

    }, []);

    useEffect(() => {


        // console.log("trueeeeeeeeee", searchedFlag);
        if (searchedFlag) {
            // console.log("came")
            handleSearch();
        } else {
            // console.log("called get all deals")
            User();
        }

    }, [searchedFlag]);

    const PageLoad = (e) => {
        const pagevalue = e.target.value;
        //setPerpage(pagevalue);
        setitemsPerPage(pagevalue);
        setcurrentPage(1);
        setmaxPageNumberLimit(5);
        setminPageNumberLimit(0);

    }


    const User = (e) => {
        GetTimeActivity()
        setIsLoading(true)
        const token = localStorage.getItem("token")
        axios({
            method: 'POST',
            url: lambda + '/clientUsers?appname=' + appname + "&clientid=" + useruniqueid + '&token=' + token
        })
            .then(function (response) {
                // console.log("response", response);
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    setUser(response?.data?.result);
                    setData(response?.data?.result?.data);
                    global.exportExcelData = response?.data?.result?.data



                    setIsLoading(false);
                    setUserSearch("");
                    setSearchedFlag(false);
                }
            }).catch((err) => {
                // console.log('error', err);
                setTableErrMsg(true)
                setIsLoading(false);
            });
    }





    const handleSearch = (e, flagggg) => {
        GetTimeActivity()
        if (flagggg) {
            setcurrentPage(1);
        }
        setmaxPageNumberLimit(5);
        setminPageNumberLimit(0);
        if (flagggg === "normalsearch") {
            setSearchedFlag(true)
        }
        setFlag(true)
        if (usersearch === "") {
            User();
        }
        else {
            setIsLoading(true)
            const token = localStorage.getItem("token")
            axios({
                method: 'POST',
                url: lambda + '/clientUsers?appname=' + appname + "&search=" + usersearch,
            })
                .then(function (response) {
                    if (response?.data?.result === "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else {
                        // console.log("response", response);
                        setUser(response?.data?.result);
                        setData(response?.data?.result?.data ?? []);
                        global.exportExcelData = response?.data?.result?.data



                        setIsLoading(false)
                    }
                }).catch((err) => {
                    // console.log('error', err);
                    setTableErrMsg(true)
                    setIsLoading(false);
                });
        }
    }

    const handleChange = (e) => {
        if (e.target.value === "") {
            //   User();
            setFlag(false)
        }
        setUserSearch(e.target.value)
    }



    const handleKeypress = (e) => {
        //it triggers by pressing the enter key
        GetTimeActivity()
        if ((e.key === "Enter")) {
            setTimeout(function () {
                handleSearch();
            }, 1000);
        }
    };
    const handleAddUser = (e) => {
        GetTimeActivity()
        navigate("/proadduser");
    }

    const handleEditUser = (e, paramuserid) => {
        // console.log('paramuserid', paramuserid)
        GetTimeActivity()
        navigate("/proedituser/" + paramuserid);
    }
    const handleDelete = (Id) => {
        setClientId(Id)
        setIsDelete(true)
    }
    const handleViewUser = (e, paramuserid) => {
        GetTimeActivity()
        // console.log('paramuserid', paramuserid)

        navigate("/viewprouser/" + paramuserid);
    }

    const clearSearch = () => {
        GetTimeActivity()
        setUserSearch("");
        User();
        setcurrentPage(1);
    }

    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No users were found</p>
                </div> </div>
        )
    }
    const handleExport = () => {

        // let k = defaultData || exportExcelData
        const modifiedArray = global.exportExcelData.map((each, i) => ({
            "S.NO": i + 1,
            "NAME": each?.contactname ?? "",
            "USER TYPE": each?.usertype ?? "",
            "EMAIL ID": typeof each?.emailId === "object" && each?.emailId !== null && each?.emailId.length > 1 ? each?.emailId.join(', ') : each?.emailId ?? "",
            "PHONE NUMBER": each?.phone ?? "",
            "STATUS": each?.status ?? "",

        }));

        exportToExcel(modifiedArray, "data");

    }
    function exportToExcel(jsonData, fileName) {
        delete jsonData['_id'];
        const worksheet = XLSX.utils.json_to_sheet(jsonData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data1 = new Blob([excelBuffer], { type: 'application/octet-stream' });
        //FileSaver.saveAs(data, `${fileName}.xlsx`);
        FileSaver.saveAs(data1, `UsersData.xlsx`);
        // console.log('data22222--->', data)
    }
    const customSort = (rows, selector, direction) => {
        const sortedData = rows.slice().sort((rowA, rowB) => {
            // use the selector function to resolve your field names by passing the sort comparators
            // const aField = selector(rowA);
            const aField = String(selector(rowA)).toLowerCase();

            //  const bField = selector(rowB);
            const bField = String(selector(rowB)).toLowerCase();

            let comparison = 0;

            if (aField > bField) {
                comparison = 1;
            } else if (aField < bField) {
                comparison = -1;
            }

            return direction === 'desc' ? comparison * -1 : comparison;
        });

        // Log the sorted data to the console
        // setSortedRecomData(sortedData)
        global.exportExcelData = sortedData
        // // console.log('Sorted Data------>:', sortedData);

        return sortedData;
    };
    // // console.log("showSessionPopupup",showSessionPopupup)
    return (
        <>
            {showSessionPopupup && <SessionPopup />}

            <div id="layout-wrapper">
                <Header />
                <Sidebar />

                {/* Start right Content here  */}

                <div className="main-content user-management client-users ss_clients" id="main-content">
                    <div className="page-content" id="page-content">
                        <div className="container-fluid" id="container-fluid">

                            <div className="row breadcrumb" id="breadcrumb-row">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title" id="breadcrumb-title">users</h4>
                                        </div>
                                        {subValDashboard?.add?.display === true && <div>

                                            <button className={subValDashboard?.add?.enable === true ? "fill-btn-style" : "fill-btn-style pe-none"} onClick={handleAddUser} id="add-user-btn">
                                                ADD USER
                                            </button>
                                        </div>}

                                    </div>
                                </div>
                            </div>

                            <div className="row table-data" id="table-data-row">
                                <div className="col-12">
                                    <div className="card" id="card">
                                        <div className="card-body" id="card-body">
                                            <div className="row mb-2" id="table-header-row">
                                                <div className="col-sm-4 button-block" id="button-block">
                                                    <div className="dataTables_length" id="datatable-length">
                                                        {subValDashboard?.export?.display === true && <button className={`fill_btn ${data.length <= 0 || subValDashboard?.export?.enable === false ? 'disable pe-none' : ''}`}
                                                            onClick={handleExport} id="export-btn">
                                                            <span className="material-icons">north_east</span>Export
                                                        </button>}

                                                    </div>
                                                </div>
                                                <div className="col-sm-8">
                                                    <div className="search-box mb-2 d-inline-block" id="search-box">
                                                        <div className="position-relative">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={usersearch}
                                                                onChange={(e) => handleChange(e)}
                                                                placeholder="Search by Name or Email"
                                                                onKeyPress={handleKeypress}
                                                                id="search-input"
                                                            />
                                                            <button
                                                                className="fill_btn"
                                                                onClick={(e) => handleSearch(e, "normalsearch")}
                                                                id="search-btn">
                                                                <span className="material-icons search-icon">search</span>
                                                            </button>
                                                        </div>
                                                        <div className="dataTables_length" id="datatable-length-reset">
                                                            <button
                                                                className="fill_btn"
                                                                onClick={clearSearch}
                                                                id="reset-btn">
                                                                <span className="material-icons-outlined">sync</span>Reset
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="text-sm-end" id="text-end"></div>
                                                </div>
                                            </div>

                                            <DataTable
                                                key={keyForRerender}
                                                columns={columns}
                                                keyField='_id'
                                                data={data}
                                                direction="auto"
                                                highlightOnHover
                                                fixedHeaderScrollHeight="300px"
                                                pagination
                                                responsive
                                                persistTableHead
                                                striped
                                                subHeaderAlign="right"
                                                defaultSortField="name"
                                                noDataComponent={customNoRecords()}
                                                paginationTotalRows={data.length}
                                                onChangeRowsPerPage={handlePerRowsChange}
                                                onChangePage={handlePageChange}
                                                paginationPerPage={rowsPerPage}
                                                paginationDefaultPage={currentPageNew}
                                                paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                                sortFunction={customSort}
                                                paginationComponentOptions={{
                                                    rowsPerPageText: 'Per page:',
                                                    rangeSeparatorText: 'of',
                                                    noRowsPerPage: false,
                                                    selectAllRowsItem: false,
                                                    selectAllRowsItemText: 'All',
                                                }}
                                                progressPending={isLoading}
                                                progressComponent={<TableLoader />}
                                                id="data-table"
                                            />

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <Modal className="new-set-modal" show={isDelete} id="clientuserDeleteModal">
                        <div className="modal-dialog modal-dialog-centered" id="clientuserModalDialog">
                            <div className="modal-content rounded-4" id="clientuserModalContent">

                                {/* Modal Header */}
                                <div className="modal-header border-0 justify-content-center position-relative" id="clientuserModalHeader">
                                    <button
                                        className="close-btn"
                                        onClick={e => handleClose()}
                                        id="clientuserCloseBtn"
                                    >
                                        <span className="material-icons">close</span>
                                    </button>
                                </div>

                                {/* Modal Body */}
                                <div className="modal-body text-center" id="clientuserModalBody">
                                    <img
                                        src={`${image}${appname}/images/web/disco-ball.gif`}
                                        alt="Delete Icon"
                                        className=""
                                        style={{ width: "100px", height: "100px" }}
                                        id="clientuserDeleteIcon"
                                    />
                                    <h3 className="modal-sm-heading" id="clientuserModalHeading">Delete</h3>
                                    <p className="modal-text" id="clientuserModalText">
                                        The changes cannot be undone.<br />
                                        Do you want to delete?
                                    </p>
                                </div>

                                {/* Modal Footer */}
                                <div className="modal-footer border-0 justify-content-center gap-3 pb-4" id="clientuserModalFooter">
                                    <button
                                        className="stroke-btn-style"
                                        onClick={handleCancel}
                                        id="clientuserCancelBtn"
                                    >
                                        No
                                    </button>
                                    <button
                                        className="fill-btn save_continue"
                                        onClick={handleDeleteClient}
                                        disabled={deleteLoader}
                                        id="clientuserConfirmDeleteBtn"
                                    >
                                        {deleteLoader ? (
                                            <img
                                                src={`${image}${appname}/images/web/rotate_right.svg`}
                                                className="loading-icon"
                                                alt="Loading"
                                                id="clientuserDeleteLoaderIcon"
                                            />
                                        ) : null}
                                        Yes
                                    </button>
                                </div>

                            </div>
                        </div>
                    </Modal>


                    <SweetAlert
                        show={tableErrMsg}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Something went wrong. Please reload again."}
                        onConfirm={e => setTableErrMsg(false)}
                        id="error-alert"
                    ></SweetAlert>

                    <Footer id="footer" />
                </div>




            </div>

        </>
    );
};

export default ClientUserList;
